import { IIconProps } from "@/components/icons/interface";

const DEFAULT_COLOR = "var(--theme-combobox-icon-color)";
const HpFilterIcon = ({ width, height, color }: IIconProps) => {
  const fillColor = color ?? DEFAULT_COLOR;
  return (
    <svg
      width={width ?? 24}
      height={height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M3.44218 5.00385C3.23628 5.02925 3.05397 5.19433 3.01224 5.39478C2.95873 5.65328 3.11927 5.91632 3.36961 5.98163C3.41769 5.99342 4.32744 5.99523 12 5.99523C19.6726 5.99523 20.5823 5.99342 20.6304 5.98163C20.7111 5.95986 20.7873 5.91542 20.8526 5.85011C21.0948 5.60793 21.024 5.19977 20.7156 5.05192C20.6667 5.02925 20.6168 5.01292 20.576 5.00657C20.517 4.99841 3.51111 4.99478 3.44218 5.00385ZM5.40136 11.51C5.17097 11.5562 5.00317 11.7621 5.00317 11.9998C5.00317 12.212 5.12925 12.3916 5.33333 12.4714L5.39229 12.4941H18.6077L18.6667 12.4714C18.8707 12.3916 18.9968 12.212 18.9968 11.9998C18.9968 11.7875 18.8707 11.6079 18.6667 11.5281L18.6077 11.5054L12.0227 11.5045C8.40091 11.5036 5.42131 11.5063 5.40136 11.51ZM7.36599 18.0188C7.2 18.0633 7.06032 18.2075 7.01587 18.3807C6.94966 18.6429 7.11655 18.9177 7.38322 18.9848C7.42585 18.9957 8.13333 18.9975 12 18.9975C15.8667 18.9975 16.5741 18.9957 16.6168 18.9848C16.8834 18.9177 17.0503 18.6429 16.9841 18.3807C16.9397 18.2057 16.7991 18.0624 16.6304 18.0179C16.5823 18.0061 16.0816 18.0043 11.9955 18.0052C8.0254 18.0052 7.40862 18.007 7.36599 18.0188Z"
        fill={fillColor}
      />
    </svg>
  );
};

export { HpFilterIcon };
